import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  bookData: [],
  loading: false,
  error: null,
};

const bookSlice = createSlice({
  name: 'book',
  initialState,
  reducers: {
    setBookData: (state, action) => {
      state.bookData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setBookData, setLoading, setError } = bookSlice.actions;

export default bookSlice.reducer;
